
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/services/residential-and-domestic-excavation-sydney/excavation-trenching-for-utilities",
      function () {
        return require("private-next-pages/services/residential-and-domestic-excavation-sydney/excavation-trenching-for-utilities.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/services/residential-and-domestic-excavation-sydney/excavation-trenching-for-utilities"])
      });
    }
  